export default __webpack_public_path__ + "static/traffic-lead-1-8019bdedd244fe6cc64b66e0729acce1.jpg";